import { chakra, Box } from "@chakra-ui/react";
import { fonts } from "theme/themeConfig";
import { colours } from "@shared/ui.design-system";

export const ItemsWrapperDiv = chakra(Box, {
  baseStyle: {
    maxWidth: { base: "100%", lg: "101%" },
    gridColumnStart: { lg: "start" },
    mt: 5,
    overflowX: { lg: "scroll" },
    ml: { lg: "-1px" },
    mr: { lg: 0 },
    pl: { md: "80px", lg: 0 },
    backgroundColor: {
      base: colours.secondary.warm,
      lg: colours.secondary.light
    },
    position: "sticky",
    top: { base: "38px", lg: "76px" },
    "@media (min-width: 1024px) and (max-width: 1279px)": {
      top: "43px"
    },
    zIndex: 2,
    "&::-webkit-scrollbar": {
      WebkitAppearance: { base: "0", lg: "none" }
    },
    "&::-webkit-scrollbar:horizontal": {
      width: "9px",
      height: "7px"
    },
    "&::-webkit-scrollbar-thumb": {
      borderRadius: "8px",
      border: "2px solid white",
      backgroundColor: colours.transparency.light
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: colours.secondary.soft,
      borderRadius: "8px"
    }
  }
});

export const ItemsWrapper = chakra(Box, {
  baseStyle: {
    display: "flex",
    gap: "5px",
    pt: "10px",
    pb: "6px",
    mb: 6,
    mt: "0.5rem",
    px: { base: 2, lg: 0 },
    listStyle: "none",
    justifyContent: "start",
    maxWidth: { lg: "100%" },
    margin: 0,
    paddingBottom: "8px",
    overflowX: { lg: "unset", base: "scroll" },
    "&::-webkit-scrollbar": {
      height: "0px"
    }
  }
});

export const LinkItem = chakra(Box, {
  baseStyle: {
    px: -1,
    pt: -5,
    pb: -2,
    fontFamily: fonts.acuminRegular,
    flexShrink: 0,
    fontSize: "1.063rem"
  }
});
